import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin)

// Get the button:
let scrollToTopBtn = document.getElementById("back-to-top");

// https://gsap.com/docs/v3/Plugins/ScrollTrigger
// Check if the button exists before proceeding
if (scrollToTopBtn) {

  // When the user scrolls down 200px from the top of the document, show the button
  window.onscroll = function() {scrollFunction()};
  function scrollFunction() {
    if (
      (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200)
    ) {
      scrollToTopBtn.classList.add("show");
    }  else {
      scrollToTopBtn.classList.remove("show");
    }
  }
}

export default function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Re-check if the button exists before adding the event listener
    var scrollToTopBtn = document.getElementById('back-to-top');
    if (scrollToTopBtn) {
      scrollToTopBtn.addEventListener('click', function() {
        gsap.to(window, { duration: 1, scrollTo: 0 });
        console.log("Clicked here");
      });
    }
  });
}